import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-marcaje-coordinates-dialog',
  templateUrl: './marcaje-coordinates-dialog.component.html',
  styleUrls: ['./marcaje-coordinates-dialog.component.scss'],
  providers: []
})
export class MarcajeCoordinatesDialog {

  markers: any[] = [];
  center: any;
  markerUrl = 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/maps/map-marker.png';
  userMarkerUrl = 'https://www.linksoluciones.com/Descargas/Otros/marker-user-27.png';

  constructor(
    public dialogRef: MatDialogRef<MarcajeCoordinatesDialog>,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
  ) {

    this.center = this.parseCoordinates(inputData.coordinates);

    this.markers = [
      { location: this.parseCoordinates(inputData.coordinates), iconSrc: this.userMarkerUrl },
      { location: this.parseCoordinates(inputData.workCenterData.coordinates), iconSrc: this.markerUrl }
    ];
  }

  parseCoordinates(coordinateStr: string): { lat: number; lng: number } {
    const [lat, lng] = coordinateStr.split(',').map(coord => parseFloat(coord.trim()));
    return { lat, lng };
  }

  closePopUp() {
    this.dialogRef.close();
  }
}
